import React from 'react';
import "./headingBox.scss";

const HeadingBox = (props) => {
  return (
    <>

      <div className="testimonialHeadBox">
        <div className="gradient-horiz-line mx-auto"></div>
        <p className="top-heading mt-4 text-center">{props.topheading}</p>
        <p className="main-gradient-heading text-center">Group LanDev AI</p>
        <span className="sub-heading text-center">
          {props.subheading}
        </span>
      </div>

    </>
  )
}

export default HeadingBox